// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1793":"c5d710f8","4004":"ad40ed99"}[chunkId] + ".chunk.css";
};